import "./App.scss"
import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {CurrencySelectDrawer} from "./cmp/currency/CurrencySelectDrawer";
import {Routing} from "./Routing";
import {useUnitsState} from "./store/UnitsState";
import {useLoadingBar} from "react-top-loading-bar";
import {MobileNavigationFooter} from "./cmp/MobileNavigationFooter";
import {useCurrencyState} from "./store/CurrencyState";

export function App() {
  const location = useLocation();
  const [count, setCount] = useState(0);
  const store = useUnitsState()
  const rates = useCurrencyState()
  const {start, complete} = useLoadingBar({
    color: "blue",
    height: 2,
  });

  useEffect(() => {
    if (!store.loading) {
      complete()
      if(!rates.currentCurrency) {
        rates.setByCode(store.company.currency)
      }
    }
  }, [store]);

  useEffect(() => {
    start()
    store.load()
    rates.load()
  }, []);

  useEffect(() => {
    setCount(count + 1);
  }, [location]);

  return <>
    <Routing/>
    <footer data-component="MobileNavigationFooter"><MobileNavigationFooter/></footer>
    <CurrencySelectDrawer/>
  </>

}